module.exports = __webpack_public_path__ + "img/img-musculoskeletal-2.fa2baa52.png";